module.exports = __webpack_public_path__ + "img/chin.3895bedf.svg";